// Language list with simplified flag SVGs
export const languageList = [
  {
    languageName: "English",
    languageCode: "en",
    countryCode: "US",
    countryFlag: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30'%3E%3Crect width='60' height='30' fill='%2319236a'/%3E%3Crect width='60' height='2.5' y='3.5' fill='%23bd3d44'/%3E%3Crect width='60' height='2.5' y='8.5' fill='%23fff'/%3E%3Crect width='60' height='2.5' y='13.5' fill='%23bd3d44'/%3E%3Crect width='60' height='2.5' y='18.5' fill='%23fff'/%3E%3Crect width='60' height='2.5' y='23.5' fill='%23bd3d44'/%3E%3Crect width='24' height='16' fill='%2319236a'/%3E%3C/svg%3E",
    direction: "ltr",
  },
  {
    languageName: "Arabic",
    languageCode: "ar",
    countryCode: "SA",
    countryFlag: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30'%3E%3Crect width='60' height='30' fill='%23000000'/%3E%3Crect width='60' height='10' y='10' fill='%23fff'/%3E%3Crect width='60' height='10' y='20' fill='%2318a84a'/%3E%3Cpath d='M15,15 L15,25 L5,25 Z' fill='%23d41b2c'/%3E%3C/svg%3E",
    direction: "rtl",
  },
  // Add more languages as needed
];
